module.exports = __webpack_public_path__ + "static/media/16 - Cowbell.dffc2e59.wav";